exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-paid-watermark{position:absolute;top:40%;font-size:80px;font-weight:700;color:rgba(200,0,0,.18);pointer-events:none;z-index:10;white-space:nowrap;user-select:none}[dir=ltr] .not-paid-watermark{left:50%;transform:translate(-50%,-50%) rotate(-30deg)}[dir=rtl] .not-paid-watermark{right:50%;transform:translate(50%,-50%) rotate(30deg)}@media screen and (max-width:650px){#credit-table-header{width:500px}[dir=ltr] #credit-table-header{padding-left:10px}[dir=rtl] #credit-table-header{padding-right:10px}#price-section2{width:500px;font-size:15px}[dir] #price-section2{padding-top:10px}[dir=ltr] #price-section2{padding-left:10px}[dir=rtl] #price-section2{padding-right:10px}#price-section{width:280px}#company-info{width:100%}#header-img{width:60px;height:60px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b651b02","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/orderInvoice/OrderInvoiceDocument.vue
// module id = 781
// module chunks = 0